import React from 'react';
import { motion } from 'framer-motion';
import { SunIcon, SunriseIcon, MoonIcon } from 'lucide-react';
const pillars = [{
  icon: SunriseIcon,
  time: 'Al despertar',
  desc: 'Recalibra tu cortisol matutino para eliminar la niebla mental.'
}, {
  icon: SunIcon,
  time: 'Al medio día',
  desc: 'Estabiliza tu temperatura central para evitar sofocos volcánicos.'
}, {
  icon: MoonIcon,
  time: 'Antes de dormir',
  desc: 'Prepara tu entorno y biología para un sueño profundo e ininterrumpido.'
}];
export function UniqueMechanism() {
  return <section className="w-full bg-cream py-20 md:py-32" data-id="element-100">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-102">
          <h2 className="text-3xl md:text-4xl font-serif text-text-brown tracking-wide mb-6" data-id="element-103">
            El Protocolo de Micro-ajustes de 5 Minutos
          </h2>
          <p className="text-lg text-text-brown-light font-light leading-relaxed" data-id="element-104">
            En lugar de cambios drásticos imposibles de mantener, este sistema
            se basa en pequeñas acciones estratégicas en puntos clave del día
            que recalibran tu cortisol y estabilizan tu temperatura central de
            inmediato.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-105">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center" data-id="element-106">
              <div className="w-16 h-16 rounded-full bg-ivory flex items-center justify-center mb-6 shadow-sm border border-taupe/20 text-gold" data-id="element-107">
                <pillar.icon className="w-8 h-8" strokeWidth={1.5} data-id="element-108" />
              </div>
              <h3 className="text-xl font-serif text-text-brown mb-3" data-id="element-109">
                {pillar.time}
              </h3>
              <p className="text-text-brown-light font-light leading-relaxed" data-id="element-110">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}